import { posthog } from 'posthog-js'
import * as Vue from 'vue'

export default ({ app, $log, route, store, $cookies }, inject) => {
  const analytics = {
    hasIdentified: false,
    userProperties: {},
    /**
        By default we send all analytics events to $log.debug to save repetitiveness
      */
    addEvent(eventName, eventData = {}, sendToSlack = false, sendToLogger = true) {
      if (process.env.APP_ANALYTICS_ENABLED === 'true') {
        app = store.getters['app/getApp']

        posthog.capture(eventName, { eventData, full_path: route.fullPath, ...this.userProperties })
      }

      if (sendToLogger) {
        $log.debug(eventName, eventData)
      }
    },

    setUserId(userId) {
      if (process.env.APP_ANALYTICS_ENABLED === 'false' || !userId || this.hasIdentified) {
        return false
      }

      this.hasIdentified = true

      posthog.identify(userId)
    },

    // User properties translate to GA4 Custom dimensions https://analytics.google.com/analytics/web/#/p266649095/customdefinitions/hub?params=_u..nav%3Ddefault%26_u..pageSize%3D25
    setUserProperty(property, value) {
      if (process.env.APP_ANALYTICS_ENABLED === 'false') {
        return false
      }

      if (property in this.userProperties) {
        return false
      }

      this.userProperties[property] = value

      posthog.people.set({ [property]: value })
    },

    reset() {
      if (process.env.APP_ANALYTICS_ENABLED === 'false') {
        return false
      }

      posthog.reset()
    }
  }

  if (process.env.APP_ANALYTICS_ENABLED === 'true') {
    posthog.init(process.env.POSTHOG_ID, {
      capture_pageview: false,
      autocapture: false,
      disable_flags: true,
      advanced_disable_feature_flags_on_first_load: true,
      disable_session_recording: true,
      ui_host: 'https://eu.posthog.com',
      api_host: 'https://p.pawpaddock.co.uk'
    })

    // Every time the route changes (fired on initialization too)
    app.router.afterEach((to, from) => {
      Vue.nextTick(() => {
        posthog.capture('$pageview', {
          $current_url: to.fullPath
        })
      })
    })
  }

  // Inject to context as $analytics
  inject('analytics', analytics)
}
